export interface AccordionState {
  isEnabled(): boolean;
  toggleSection(section: number): void;
  isSectionOpen(section: number): boolean;
}

/**
 * Utility class that manages the state of collapsible sections. The different section divs in a
 * view layer can hook into these methods to determine if they should show or hide themselves.
 *
 * This implementation allows at most one section to be open at any time. Sections may be
 * numbered in any fashion. Upon construction, all sections are assumed to be closed.
 */
export class SingleSectionAccordion implements AccordionState {

  private currentOpenSection: number = null;

  /**
   * Returns true iff the accordion can be used.
   * @returns {boolean}
   */
  public isEnabled(): boolean {
    return true;
  }

  /**
   * Toggles the state of the given section. If the given section is closed, it will open
   * that section and close the others; if it is already open, it will close that section,
   * leaving them all closed.
   * @param section The section number to toggle
   */
  public toggleSection(section: number): void {
    if (section === this.currentOpenSection) {
      this.currentOpenSection = null;
    } else {
      this.currentOpenSection = section;
    }
  }

  /**
   * Returns true if the given section is open, false if it is closed.
   * @param section The section to check
   */
  public isSectionOpen(section: number): boolean {
    return (this.currentOpenSection === section);
  }

}

/**
 * Alternative implementation of AccordionState that has all the sections open and doesn't allow
 * any of them to close.
 */
export let StaticAccordion: AccordionState = {
  isEnabled: () => false,
  toggleSection: () => {},
  isSectionOpen: () => true
};
